import {RestRequestBLOB} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";

export const downloadImportTemplate = async (demandId, successCallback = () => {}, errorCallback  = () => {}) => {
    try {
        RestRequestBLOB(Endpoints.DEALINGS_EXPORT(demandId))
            .then(successCallback)
            .catch(errorCallback);
    } catch (error) {
    }
}

